import { LANGS, STR } from "./i18n.js";
import { updateMetaTags } from "./branding.js";

const LS_KEY = "dca_lang";

export function detectLang() {
  // 1) URL ?lang=en|fr|es  2) localStorage  3) navegador
  const url = new URL(window.location.href);
  const q = url.searchParams.get("lang");
  if (q === LANGS.EN || q === LANGS.FR || q === LANGS.ES) {
    localStorage.setItem(LS_KEY, q);
    return q;
  }
  const saved = localStorage.getItem(LS_KEY);
  if (saved) return saved;

  const nav = (navigator.language || "en").toLowerCase();
  let guess = LANGS.EN; // Default to English
  if (nav.startsWith("es")) {
    guess = LANGS.ES;
  } else if (nav.startsWith("fr")) {
    guess = LANGS.FR;
  } else if (nav.startsWith("en")) {
    guess = LANGS.EN;
  }
  localStorage.setItem(LS_KEY, guess);
  return guess;
}

export function setLang(code) {
  localStorage.setItem(LS_KEY, code);
  // Update URL without reload for better UX
  const url = new URL(window.location.href);
  url.searchParams.set('lang', code);
  window.history.pushState({}, '', url.toString());
  
  // Update meta tags immediately
  const t = (key) => (STR[code] && STR[code][key]) || key;
  updateMetaTags(code, t);
  
  // Trigger a custom event for React components to re-render
  window.dispatchEvent(new CustomEvent('languageChanged', { detail: code }));
}

export function t(lang, key) {
  return (STR[lang] && STR[lang][key]) || key;
}